module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-11.0c92c9a5.png";